import React, { Component } from 'react'
import { List, Card } from 'antd'

import Edit from './Edit'

import { privileges } from '@services/api'

export default class Privileges extends Component<any> {
    state = {
        list: [],
        loading: true
    }

    componentDidMount() {
        this.updatePrivilegeList()
    }

    updatePrivilegeList = async () => {
        const { policy_id } = this.props
        const list = (await privileges.getList({ policy_id })).data
        this.setState({ list, loading: false })
    }

    render() {
        const { loading, list } = this.state
        const { disable } = this.props
        return (
            <Card
                headStyle={{ backgroundColor: '#dadce0' }}
                bodyStyle={{ padding: '0.7rem' }}
                loading={loading}
                title={`מאפייני פוליסה (סה"כ נמצאו ${list.length} מאפיינים)`}
            >
                {!disable && (
                    <Edit
                        disable={disable}
                        privilegeUpdated={() => this.updatePrivilegeList()}
                        policy_id={this.props.policy_id}
                    />
                )}
                <List
                    className="center-table"
                    style={{ width: '100%' }}
                    rowKey="id"
                    loading={loading}
                    dataSource={list}
                    pagination={{
                        pageSize: 10
                    }}
                    renderItem={item => (
                        <Edit
                            item={item}
                            disable={disable}
                            policy_id={this.props.policy_id}
                            privilegeUpdated={() => this.updatePrivilegeList()}
                        />
                    )}
                />
            </Card>
        )
    }
}
